import React from 'react'
import { videos } from 'src/constants/videos'
import styled from 'styled-components'
import { teamIds } from 'src/constants/personalizationIds'
import BallySportsNBA from 'src/components/page/bally-sports-nba'

export default (props) => (
  <StyledContainer>
    <BallySportsNBA
      location={props.location}
      video={videos.bally_cavaliers.videoUrl}
      staticAnnotation={videos.bally_cavaliers.staticAnnotation}
      title="Watch the Cleveland Cavaliers live"
      subtitle={
        <>
          Stream the Cavs on FanDuel Sports Network Ohio. <br /> Regional restrictions apply.
        </>
      }
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-cavs-lockup.png?w=450&ch=width&auto=format,compress"
      teamId={teamIds['Cleveland Cavaliers']}
      showFanduelCard={true}
    />
  </StyledContainer>
)
const StyledContainer = styled.div`
  .content-container .hero-note {
    font-size: 0.9rem;
    font-style: italic;
  }
`
